import React from 'react';
import { Icon } from 'components/Icon';
import styles from './styles.css';
import { Trans } from 'react-i18next';

export default ({ showModal, ...rest }) => {
  return (
    <span
      className={styles.watchTutorial}
      onClick={() => showModal('tutorial', rest)}
    >
      <span className={styles.playIcon}>
        <Icon name="play" />
      </span>
      <Trans ns="home">{'common:general.watch_tutorial'}</Trans>
    </span>
  );
};
